import React from 'react'
import ChartImage from '../../assets/icons/chart.png'

function HideData({message, dataMessage}) {
    return (
        <div className="text-center flex flex-col items-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-inner-2xl rounded-lg p-4 w-1/2">
            <img
                src={ChartImage}
                className="w-1/3 mx-auto mb-3"
                alt="Credit Notice"
            />
            <h3 className="text-secondarytwo text-left sm:text-f-12 md:text-f16 lg:text-f20 font-semibold mb-2 text-center">
                {message}
            </h3>
            <div className="text-secondary text-center sm:[8px] md:text-[10px]">{dataMessage?.split("_")?.join(" ")}</div>
        </div>
    )
}

export default HideData